import { CARD_DRAGONBONES_PATH } from 'Constants/Dragonbones';
import { PlusThreeLayout } from 'Layouts/Card/PlusThree/PlusThreeLayout';
import { getLayout, GLayout } from 'Utility/layout/LayoutHelper';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';
import BaseCard from './BaseCard';
import { CardType } from './CardType';

export default class PlusThreeCard extends BaseCard {
    private layout: GLayout<PlusThreeLayout>;
    
    public onCreate(params: any): void {
        params.cardFrontTexture = 'cardplusthree';
        params.type = CardType.plus_three;
        super.onCreate(params);

        this.layout = getLayout(PlusThreeLayout);
        this.addChild(this.layout.root);
    }
    
    public static async preload(): Promise<void> {
        addDragonbonesResources('festival4_exp', `${CARD_DRAGONBONES_PATH}/PlusThree/`);
    }
}
